/* Supplied by DefinePlugin; see config/webpack.config.dev.js and .prod.js */
/* globals REACT_APP_COGNITO */

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import Auth from '@aws-amplify/auth';
import Amplify from '@aws-amplify/core';
import { ApolloProvider } from 'react-apollo';
import mixpanel from 'mixpanel-browser';
import { PersistGate } from 'redux-persist/integration/react';
import bulletTrain from 'bullet-train-client';
import { store, history, persistor } from 'store';
import 'styles/global.css';
import { App } from 'pages';
import ScrollToTop from 'containers/ScrollToTop';
import AWSAppSyncClient from 'aws-appsync';
import { AUTH_TYPE } from 'aws-appsync/lib/link/auth-link';
import * as serviceWorker from './registerServiceWorker';
// import registerServiceWorker, { unregister } from './registerServiceWorker';
import { isDev } from 'common/utils';
import { updateFeatures } from 'actions/settings';
// Import polyfills for IE 11
import 'babel-polyfill';

// Dev
Amplify.configure({
  Auth: {
    region: REACT_APP_COGNITO.REGION, // REQUIRED - Amazon Cognito Region
    userPoolId: REACT_APP_COGNITO.USER_POOL, //OPTIONAL - Amazon Cognito User Pool ID
    userPoolWebClientId: REACT_APP_COGNITO.WEB_CLIENT_ID, //OPTIONAL - Amazon Cognito Web Client ID
    mandatorySignIn: true,
  },
});

const client = new AWSAppSyncClient({
  disableOffline: false,
  url: REACT_APP_COGNITO.GRAPHQL_ENDPOINT,
  region: REACT_APP_COGNITO.REGION,
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () =>
      (await Auth.currentSession()).getAccessToken().getJwtToken(),
  },
  complexObjectsCredentials: () => Auth.currentCredentials(),
});

if (
  process.env.NODE_ENV !== 'production' &&
  process.env.REACT_APP_DISABLE_LOGGERS === 'false'
) {
  Amplify.Logger.LOG_LEVEL = 'DEBUG';
}

mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN);

bulletTrain.init({
  environmentID: process.env.REACT_APP_BULLET_TRAIN_API,
  onChange: (oldFlags, params) => {
    //Occurs whenever flags are changed

    const features = {};
    const { isFromServer } = params; //determines if the update came from the server or local cached storage

    //Check for a feature
    if (isFromServer) {
      features.allowUploadShapefile = bulletTrain.hasFeature(
        'allow_upload_shapefile'
      );
      features.showTutorials = bulletTrain.hasFeature('show_tutorials');
    }
    store.dispatch(updateFeatures(features));
  },
});

ReactDOM.render(
  <Provider store={store}>
    <ApolloProvider client={client}>
      <ConnectedRouter history={history}>
        <ScrollToTop>
          <PersistGate loading={null} persistor={persistor}>
            <App />
          </PersistGate>
        </ScrollToTop>
      </ConnectedRouter>
    </ApolloProvider>
  </Provider>,
  document.getElementById('root')
);

// Inititalize Raven
if (window && window.Raven && !isDev()) {
  if (!window.Raven.isSetup()) {
    window.Raven.config(process.env.REACT_APP_SENTRY_DNS).install({
      environment: process.env.NODE_ENV,
      debug: true,
      whitelistUrls: [
        /getsentry\.com/,
        /cdn\.getsentry\.com/,
        /agi-grow-staging\.applydigital\.io/,
        /my\.agigrow\.com/,
      ],
    });
  }
}

// Register serice worker for offline use
serviceWorker.register();



// WEBPACK FOOTER //
// ./src/index.js